import { FormInstance } from 'antd';
import React from 'react';

import { Icon } from '@components/metrics-builder/components/MetricList';
import ReadyToMapGroups from '@components/quick-map/components/ReadyToMap/ReadyToMapGroups';
import DeleteActiveSvg from '@icons/mapping-panel/delete-active-icon.svg';
import DeleteSvg from '@icons/mapping-panel/delete-icon.svg';

import styles from './index.less';

interface IReadyToMap {
  form: FormInstance;
  repeatedNames: string[];
}

const ReadyToMap: React.FC<IReadyToMap> = ({ form, repeatedNames }) => {
  const handleDeleteAll = () => {
    form?.resetFields();
  };

  return (
    <div className={styles.readyToMapWrapper}>
      <div className={styles.readyToMapTitle}>
        <span className={styles.mapTitleHeadline}>Quick Map</span>
        <span className={styles.mapTitleSubtitle}>Set Mapped Name and category</span>
      </div>
      <div className={styles.tableHeader}>
        <div className={styles.titleItem}>
          <span style={{ width: '34px' }} />
          Raw Event
        </div>
        <span style={{ width: '32px' }} />
        <div className={styles.titleItem}>
          <span style={{ width: '11px' }} />
          Mapped Event Category
        </div>
        <span style={{ width: '32px' }} />
        <div className={styles.titleItem} style={{ justifyContent: 'space-between' }}>
          <div className={styles.titleSubItem}>
            <span style={{ width: '11px' }} />
            Mapped Event Name
          </div>
          <div className={styles.deleteAllBtn} onClick={handleDeleteAll}>
            Delete All
            <Icon
              component={DeleteSvg}
              activeComponent={DeleteActiveSvg}
              style={{ fontSize: '16px', marginLeft: '4px' }}
            />
          </div>
        </div>
      </div>
      <ReadyToMapGroups form={form} repeatedNames={repeatedNames} />
    </div>
  );
};

export default ReadyToMap;
